import { Injectable } from '@angular/core';

import { SwUpdate, UnrecoverableStateEvent, VersionEvent } from '@angular/service-worker';
import { Logger } from './helper/app-error-logger';
import { UiHelper } from './helper/ui-helper';
import { Utils } from './helper/utils';

const log = new Logger('UpdateService');

@Injectable()
export class UpdateService {

    initTime: number;

    constructor(private swUpdate: SwUpdate) {
    }

    init() {
        log?.info('Init update service...');

        this.swUpdate.versionUpdates.subscribe(e => this.onVersionUpdates(e));
        this.swUpdate.unrecoverable.subscribe(e => this.onUpdateUnrecoverable(e));

        // this.swUpdate.available.subscribe(evt => {
        //     const snack = this.snackbar.open('Update Available', 'Reload');
        //     snack
        //         .onAction()
        //         .subscribe(() => {
        //             window.location.reload();
        //         });

        //     setTimeout(() => {
        //         snack.dismiss();
        //     }, 6000);
        // });

        this.initTime = Date.now();

        // Direkt nach dem Start auf Updates prüfen
        setTimeout(() => this.checkForUpdate(), 5 * 60 * 1000);

        // Direkt nach dem Start auf Updates prüfen
        setTimeout(() => this.checkForUpdate(), 0); // 3 * 1000);
    }

    async checkForUpdate() {
        log?.info('checkForUpdate');

        try {
            await this.swUpdate.checkForUpdate();
        } catch (err) {
            log.warn(Utils.getErrorMessage(err), err);
        }
    }

    async onVersionUpdates(evt: VersionEvent) {
        log?.info(`onVersionUpdates: ${evt?.type}`, evt);

        switch (evt.type) {
            case 'VERSION_DETECTED':
                {
                    log?.info(`Downloading new app version: ${evt.version?.hash}`);
                    break;
                }

            case 'VERSION_READY':
                {
                    log?.info(`Current app version: ${evt.currentVersion?.hash}`);
                    log?.info(`New app version ready for use: ${evt.latestVersion?.hash}`);

                    await this.swUpdate.activateUpdate();

                    window.location.reload();

                    break;
                }

            case 'VERSION_INSTALLATION_FAILED':
                {
                    log?.info(`Failed to install app version '${evt.version?.hash}': ${evt.error}`);
                    break;
                }
        }
    }

    onUpdateUnrecoverable(e: UnrecoverableStateEvent) {
        log.warn('onUpdateUnrecoverable', e);
        window.location.reload();
    }
}